import { render, staticRenderFns } from "./index.vue?vue&type=template&id=483c3517&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=483c3517&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=483c3517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c3517",
  null
  
)

export default component.exports